import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '~/lib/request';

export type SubscriptionPlan = {
  id: string;
  name: string;
  price: number;
  duration: number;
  is_active: boolean;
};

function useSubscriptionPlans() {
  const result = useQuery({
    queryKey: ['subscriptionPlans'],
    queryFn: () => subscriptionApi.get('api/plans/active').json<SubscriptionPlan[]>(),
    throwOnError: true,
  });

  return result.data;
}

export default useSubscriptionPlans;
